import React from 'react'
import PropTypes from 'prop-types'

import styled from 'styled-components'

import FlexContainer from 'components/corpSite/components/shared/flex-container'

import Paper from 'components/corpSite/components/careguide-corp/paper'

import makeStats from './styled'

const StyledStat = makeStats('div')

const Stat = (props) => (
  <StyledStat>
    <h2>{props.cover}</h2>
    <div className='imageText'>
      <h3>{props.header}</h3>
    </div>
  </StyledStat>
)

Stat.propTypes = {
  cover: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
}

const StyledPaper = styled(Paper)`
  display: flex;
  justify-content: space-evenly;
`

const Stats = ({ stats }) => (
  <StyledPaper>
    <FlexContainer direction='column' flexWrap justifyContent='center' alignItems='center'>
      <FlexContainer direction='row' justifyContent='space-between' mobileWrap>
        <Stat
          cover={stats.customers}
          mobileRow
          header='Customers Across North America'
          width={'164px'}
          align={'center'}
        />
        <Stat
          cover={stats.messages}
          mobileRow
          header='Messages Exchanged'
          width={'164px'}
          align={'center'}
        />
        <Stat
          cover={stats.calls}
          mobileRow
          header='Secure Calls Made'
          width={'164px'}
          align={'center'}
        />
      </FlexContainer>
    </FlexContainer>
  </StyledPaper>
)

Stats.propTypes = {
  stats: PropTypes.object.isRequired,
}

export default Stats
